//handles redux exhibitor state
import {createSlice} from '@reduxjs/toolkit';

const initialStateValue = ''

export const authSlice = createSlice({
    name:"auth",
    initialState:{value:initialStateValue},
    reducers:{
        rxShowAmplifyAuth:(state,action)=>{
            state.value = action.payload
        },
    }
})

export const {rxShowAmplifyAuth} = authSlice.actions

export default authSlice.reducer;
